module.exports = __webpack_public_path__ + "media/images/generator3-157c02a7ab7620154c0404a60115892a.webp";